import type { IconData } from '@stacksjs/iconify-core'

export const tt4x3: IconData = {
  "body": "<path fill=\"#fff\" d=\"M0 0h640v480H0z\"/><path fill=\"#e00000\" fill-rule=\"evenodd\" d=\"M463.7 480L0 1v478.8zM176.3 0L640 479V.2z\"/><path fill=\"#000001\" fill-rule=\"evenodd\" d=\"M27.7.2h118.6l468.2 479.3H492.2z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default tt4x3
